export default __webpack_public_path__ + "static/circle-fern-decoration-ocean-db0bd0d1c42dcc754b819f3f1d91bf26.webp";